<template>
    <div class="row" id="ajuda">
        <h6 class="col-12">Como podemos ajudar?</h6>
        <div class="col-12">
            <BotaoVerMais
                :classes="'w-100 text-left mb-3'"
                :target="'contato'" 
                :textoAbrir="'Quero contato com a assistência'"
                :textoFechar="'Quero contato com a assistência'"
                :id="'abrirContato'"
            />
            <b-collapse id="contato">
                <div class="row">
                    <div class="col-12 mb-2 text-center">
                        <a :href="tratarUrl()" 
                            role="button" 
                            class="btn btn-success mr-3" 
                            v-if="!$func.isEmpty(whatsappContato)"
                            target="_blank"
                        >
                            Whatsapp <i class="fab fa-whatsapp "></i>
                        </a>
                        <a :href="`tel:${telefoneContato}`"
                            role="button" 
                            class="btn btn-primary"
                            v-if="!$func.isEmpty(telefoneContato)"
                            v-b-popover.hover.top="`Ligar para ${telefoneContato}`"
                            target="_blank"
                        >
                            Ligar <i class="fas fa-phone"></i>
                        </a>
                    </div>
                    <div class="col-12 mb-2">
                        ou envie uma mensagem...
                        <b-form-textarea 
                            id="mensagem-contato" 
                            name="mensagemContato" 
                            rows="5"
                            size="sm"
                            v-model="mensagemContato" 
                            placeholder="Escreva uma mensagem..." 
                        />
                    </div>
                    <div class="col-12 text-right">
                        <button type="button" class="btn btn-warning text-white" @click="enviarContato(false)" :disabled="loading">
                            {{ loading ? 'Aguarde ...' : 'Enviar' }} 
                            <i class="fas fa-paper-plane"></i>
                        </button>
                    </div>
                </div>
            </b-collapse>
        </div>
        <div class="col-12 mt-2">
            <BotaoVerMais
                :classes="'w-100 text-left mb-3'"
                :target="'cancelar'"
                :textoAbrir="'Quero cancelar o meu atendimento'"
                :textoFechar="'Quero cancelar o meu atendimento'"
                :id="'abrirCancelar'"
            />
            <b-collapse id="cancelar">
                <div class="col-12 mb-2">
                    <b-form-textarea 
                        id="mensagem-cancelamento" 
                        name="mensagemCancelamento" 
                        rows="5"
                        size="sm"
                        v-model="mensagemCancelamento" 
                        placeholder="Nos conte o motivo..." 
                    />
                </div>
                <div class="col-12 text-center">
                    <button type="button" class="btn btn-danger text-white" @click="enviarContato(true)" :disabled="loading">
                        {{ loading ? 'Aguarde ...' : 'Cancelar serviço' }} 
                    </button>
                </div>
            </b-collapse>
        </div>
    </div>
</template>

<script>
import BotaoVerMais from "@/components/Botoes/BotaoVerMais.vue";
import { mapGetters, mapState } from "vuex";

export default {
    data(){
        return {
            mensagemContato: '',
            mensagemCancelamento: '',
            loading: false
        }
    },
    components: {
        BotaoVerMais
    },
    computed: {
        ...mapGetters('Atendimento', {
            whatsappContato: "whatsappContato",
            enviarContatoWhatsapp: "enviarContatoWhatsapp",
            telefoneContato: "telefoneContato",
        }),
        ...mapState('Atendimento', {
           idAtendimentoUrl: 'idAtendimentoUrl' 
        }),
    },
    methods: {
        enviarContato (cancelamento) {
            this.loading = true;

            if (
                (cancelamento && this.$func.isEmpty(this.mensagemCancelamento)) || 
                (!cancelamento && this.$func.isEmpty(this.mensagemContato))
            ) {
                this.$bvModal.msgBoxOk('A mensagem é obrigatória', {centered: true});
                this.loading = false;
                return false;
            }

            let tipoSolicitacao = 'contato';
            let mensagem = '';
            if (cancelamento === true) {
                tipoSolicitacao = 'cancelamento';
                mensagem += `O solicitante deseja fazer o <b>cancelamento</b> do serviço. <br><br>`;
                mensagem += this.mensagemCancelamento.replace(/\r?\n/g, '<br>');
            } else {
                mensagem += this.mensagemContato.replace(/\r?\n/g, '<br>');
            }

            const h = this.$createElement;
            this.$bvModal.msgBoxConfirm(h('div', [
                'Confirma o envio da ',
                h('strong', 'solicitação de ' + tipoSolicitacao),
                '?',
            ]), {
                okTitle: 'Sim',
                cancelTitle: 'Não',
                cancelVariant: 'default',
                centered: true
            }).then(value => {
                this.loading = value;
                if (value) {
                    if (this.enviarContatoWhatsapp == 'S' && !this.$func.isEmpty(this.whatsappContato)) {
                        const array = this.whatsappContato.split('&text=');
                        let url = array[0];
                        if (array.length == 2) {
                            mensagem = mensagem.replace('<br>', '\n').replace(/<[^>]*>?/gm, '');

                            url += `&text=${encodeURIComponent(mensagem)}`;
                            window.open(url);
                            this.mensagemContato = '';
                            this.mensagemCancelamento = '';
                        }
                        this.loading = false;
                    } else {
                        this.$http.post(`${process.env.VUE_APP_URL_API}/client/atendimento/${this.idAtendimentoUrl}/contato`, {
                            mensagem,
                            cancelamento
                        }).then(response => {
                            this.$bvModal.msgBoxOk(response.data.mensagem, {centered: true});
                            this.mensagemContato = '';
                            this.mensagemCancelamento = '';
                            this.loading = false;
                        }).catch((error) => {
                            let mensagem = '';
                            if (error.response.status < 500) {
                                mensagem = error.response.data.mensagem;
                            } else {
                                if (cancelamento) {
                                    mensagem = 'Erro ao solicitar o cancelamento para a assistência';
                                } else {
                                    mensagem = 'Erro ao enviar o contato para a assistência';
                                }
                            }
                            this.$bvModal.msgBoxOk(mensagem, {centered: true});
                            this.loading = false;
                        });
                    }
                }
            }).catch(() => {});
        },

        tratarUrl() {
            if (this.$func.isEmpty(this.whatsappContato)) {
                return '';
            }

            const array = this.whatsappContato.split('&text=');
            let url = array[0];
            if (array.length == 2) {
                url += `&text=${encodeURIComponent(array[1])}`;
            }
            return url;
        }
    },
}
</script>
